module.exports = __webpack_public_path__ + "static/media/standup-icon.fb5322c0.svg";